<template lang="pug"></template>

<script>
export default {
    name: 'BotaoTerritorio',
    componentOptions: {
        title: 'Territorio',
        actions: [
            [
                {
                    name: 'Território',
                    iconClass: 'lyra-icon lyra-mapa',
                    showView: false,
                    action: 'abrirTerritorio',
                    route: 'Territorio',
                    nameTranslationKey: 'mensagens.menuLateral.territorio'
                }
            ]
        ]
    },

    methods: {
        abrirTerritorio() {
            if (this.$route.name !== 'Territorios') {
                this.$router.push({ name: 'Territorios' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
